import { helper } from '@ember/component/helper';

import { formatDate, offsetDate } from 'rise-ui/utils/date.js';
import { minDate, maxDate } from 'rise-ui/config/time-series/query-params.js';

export default helper(function qpDateRelHelper([ range ]) {
  const now = new Date();
  const today = formatDate(new Date(), 'url');
  const isDecade = range === 'decade';
  return (range === 'week' || range === 'month' || range === 'year' || range === 'decade')
    ? [ formatDate(offsetDate(now, isDecade ? -10 : -1, isDecade ? 'years' : range), 'url'), today ]
    : [ minDate, maxDate ];
});
